export function sameOrga<T extends { organizationId: string }>(a: T, b: T) {
  return a === b || a.organizationId === b.organizationId;
}
